/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function ($) {
  'use strict';

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container: ' + container);
  //     console.log('Variant: ' + variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   var ids = $("#hid_prd_ids").val();
  //   var flag = '0';
  //   if (cart) {
  //     $.each(cart.items, function(index, item) {
  //       if(ids !== undefined && ids.indexOf(item.product_id) >= 0 ) {
  //         flag = '1';
  //         return false;
  //       }
  //     });
  //     if ($("#hid_wine_flag") !== undefined){
  //       $("#hid_wine_flag").val(flag);
  //     }
  //     //console.log('Cart: ' + cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });

  // Debounced scroll listeners.  Up and down only fire on directions changes
  // These events are useful for creating sticky headers and footers.
  //document.addEventListener('theme:scroll', e => { console.log(e); });
  //document.addEventListener('theme:scroll:up', e => { console.log(e); });
  //document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  //document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
  function checkStatus() {
    let flag = $('#hid_wine_flag').val();
    let check_agrrement = $('#check_agrrement');
    let btn_checkout = $('#btn_checkout');
    let other_pay_buttons = $('div.grid__item.additional-checkout-buttons');

    if (flag !== undefined) {
      if (flag === '1') {
        if (check_agrrement.is(':checked') && $('#select_age').val() >= 20) {
          btn_checkout.attr("disabled", false);
          btn_checkout.removeClass('btn_disabled');
          btn_checkout.addClass('btn_normal');

          //カード以外の支払い方法
          if (other_pay_buttons) {
            other_pay_buttons.removeClass('hidden');
          }
        } else {
          btn_checkout.attr("disabled", true);
          btn_checkout.removeClass('btn_normal');
          btn_checkout.addClass('btn_disabled');

          //カード以外の支払い方法
          if (other_pay_buttons) {
            other_pay_buttons.addClass('hidden');
          }
        }
      } else {
        if (check_agrrement.is(':checked')) {
          btn_checkout.attr("disabled", false);
          btn_checkout.removeClass('btn_disabled');
          btn_checkout.addClass('btn_normal');

          //カード以外の支払い方法
          if (other_pay_buttons) {
            other_pay_buttons.removeClass('hidden');
          }
        } else {
          btn_checkout.attr("disabled", true);
          btn_checkout.removeClass('btn_normal');
          btn_checkout.addClass('btn_disabled');

          //カード以外の支払い方法
          if (other_pay_buttons) {
            other_pay_buttons.addClass('hidden');
          }
        }
      }
    }
  }

  function checkContactForm() {
    if ($('#ContactFormName').val().trim() == '' ||
      $('#ContactFormEmail').val().trim() == '' ||
      $('#ContactFormMessage').val().trim() == '') {
      $('#btn_contact_send').attr("disabled", true);
      $('#btn_contact_send').removeClass("btn--primary");
    } else {
      $('#btn_contact_send').attr("disabled", false);
      $('#btn_contact_send').addClass("btn--primary");
    }
  }

  function openExternalLinksInNewTab() {
    var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].relList.add('noreferrer', 'noopener');
      }
    }
  };

  $(document).ready(function () {
    //カートページ
    if ($('#hid_wine_flag').val() !== undefined) {
      checkStatus();
      $('#check_agrrement').change(function () {
        checkStatus();
      });

      $('#select_age').on('change', function () {
        checkStatus();
      });
    }

    //お問い合わせページ
    if ($('#ContactFormName').length !== 0) {
      checkContactForm();
      $('#ContactFormName').bind('input propertychange', function () {
        checkContactForm();
      });
      $('#ContactFormEmail').bind('input propertychange', function () {
        checkContactForm();
      });
      $('#ContactFormMessage').bind('input propertychange', function () {
        checkContactForm();
      });
    }
  });

  //add br by adlab
  document.addEventListener('DOMContentLoaded', () => {
    const targets = document.querySelectorAll('.product__title, .grid__title');

    targets.forEach(el => {
      let html = el.innerHTML;

      // すでに <br> が入っていない場合のみ処理
      html = html.replace(/】(?!\s*<br\s*\/?>)/, '】<br>');

      el.innerHTML = html;
    });
  });

  openExternalLinksInNewTab();
}(pipelineVendor.$));


